module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.b4a1cc8b.svg";